import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import buildColumns from "./columns";
import MaterialUiDataGridPremium from "../../../components/Tables/DataGridPremium/MaterialUiDataGridPremium";

export default function MVPAssetsTable(props) {
  const {
    activeFacility,
    handleRowClick,
    highlightedZone,
    onClick,
    state,
    timeZone,
    zones
  } = props;
  const { assets = [], assetHistories = null, isAssetHistory } = state;
  const history = useHistory();
  const { historyTableColumns } = buildColumns({
    history,
    onClick,
    timeZone,
    zones,
  });
  const assetResults = useSelector((state) => state.user.results);

  //for fullRows, if activeFacility is not null, use the activeFacility to filter both assetHistories and assetResults potentially.
  // If activeFacility is null, dont filter.
  const fullRows = []
  if (activeFacility) {
    fullRows.push(
      ...(isAssetHistory
        ? assetHistories?.filter((history) => history?.facilityId === activeFacility)
        : assetResults?.filter((result) => result?.facilityId === activeFacility))
    );
  }
  else {
    fullRows.push(
      ...(isAssetHistory ? assetHistories : assetResults)
    );
  }

  //Filter based on highlightedZone
  const filteredRows = highlightedZone
    ? fullRows.filter((row) => row?.zone?.zoneId === highlightedZone)
    : fullRows;

  return (
    <>
      <MaterialUiDataGridPremium
        autoHeight={false}
        checkboxSelection={false}
        columns={historyTableColumns}
        delayedLoad={filteredRows?.length === 0 ? false : true}
        enableIsRowSelectable={false}
        getRowId={(row) => {
          return (isAssetHistory ? row.assetHistoryId : row.assetId)
        }}
        getRowClassName={(params) => {
          return params?.row?.zone?.zoneId === highlightedZone
            ? "highlighted-row pointer"
            : "pointer";
        }}
        highlightedRowColor="#A0C46D" //lx green
        loading={false}
        onRowClick={handleRowClick}
        rowCount={isAssetHistory ? assetHistories?.length : assets?.length}
        rows={filteredRows}
        showGridToolbar={true}
        useUseMemoHook={false}
      />

    </>
  );
}